import React from "react";
import ExpandableCellList from "components/common/ExpandableCellList";
import AssetLink from "security-app/components/Assets/plugin/AssocAssetsWidget/AssetLink";
import SidebarNavigationLink from "components/layout/RightSidebar/SidebarNavigationLink";
import SidebarInvestigationDetails from "security-app/components/Investigations/Details/SidebarInvestigationDetails";
export function InvestigationsCell({ investigations = [] }) {
  const sortedInvestigations = [...investigations].sort((a, b) => a.name.localeCompare(b.name));
  return /* @__PURE__ */ React.createElement(
    ExpandableCellList,
    {
      items: sortedInvestigations,
      itemKey: ({ id }) => id,
      renderItem: (investigation) => /* @__PURE__ */ React.createElement(SidebarNavigationLink, { content: SidebarInvestigationDetails(investigation.id) }, investigation.name)
    }
  );
}
export function AssociatedAssetsCell({ assets = [] }) {
  const sortedAssets = [...assets].sort((a, b) => a.name.localeCompare(b.name));
  return /* @__PURE__ */ React.createElement(
    ExpandableCellList,
    {
      items: sortedAssets,
      itemKey: (asset) => {
        var _a;
        return (_a = asset.id) != null ? _a : asset.name;
      },
      renderItem: (asset) => asset.id ? /* @__PURE__ */ React.createElement(AssetLink, { asset, noIcon: true }) : /* @__PURE__ */ React.createElement("span", null, asset.name)
    }
  );
}
